// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SystemMessageMenu__menu-placeholder-accc68 {
  display: flex;
  opacity: 0;
  padding-top: 3px;
  transition: opacity 0.15s ease-in-out;
  align-self: flex-start;
  position: sticky;
  top: 0;
  min-width: 120px;
  margin: 0 8px;
  justify-content: flex-end;
  padding-inline-end: 4px;
  z-index: 1;
}

.SystemMessageMenu__menu-placeholder-accc68.SystemMessageMenu__opened-bcf46a {
  opacity: 1;
}

.SystemMessageMenu__item-container-d8387d {
  align-self: flex-start;
  margin-inline-start: 4px;
}

.SystemMessageMenu__item-container-d8387d .SystemMessageMenu__icon-be1327 {
  fill: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/SystemMessageLayout/SystemMessageMenu/SystemMessageMenu.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,qCAAA;EACA,sBAAA;EACA,gBAAA;EACA,MAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".menu-placeholder {\n  display: flex;\n  opacity: 0;\n  padding-top: 3px;\n  transition: opacity 0.15s ease-in-out;\n  align-self: flex-start;\n  position: sticky;\n  top: 0;\n  min-width: 120px;\n  margin: 0 8px;\n  justify-content: flex-end;\n  padding-inline-end: 4px;\n  z-index: 1;\n}\n\n.menu-placeholder.opened {\n  opacity: 1;\n}\n\n.item-container {\n  align-self: flex-start;\n  margin-inline-start: 4px;\n}\n\n.item-container .icon {\n  fill: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu-placeholder": `SystemMessageMenu__menu-placeholder-accc68`,
	"menuPlaceholder": `SystemMessageMenu__menu-placeholder-accc68`,
	"opened": `SystemMessageMenu__opened-bcf46a`,
	"item-container": `SystemMessageMenu__item-container-d8387d`,
	"itemContainer": `SystemMessageMenu__item-container-d8387d`,
	"icon": `SystemMessageMenu__icon-be1327`
};
module.exports = ___CSS_LOADER_EXPORT___;
